module.exports = __webpack_public_path__ + "a60a1def77386da08530b8d286320c3e.svg";